import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCouriersQuery } from '../hooks/useInvoiceBulk';

/**
 * 택배사 코드 참조표. 업로드 시 배송업체번호(courier_code) 입력을 돕는다.
 * 에버라인 자체 코드체계(CJ/HANJIN/LOTTE/EPOST/KDEXP…). 기본 접힘.
 */
export const CourierReference = () => {
  const query = useCouriersQuery();
  const [open, setOpen] = useState(false);

  const couriers = query.data ?? [];

  return (
    <div
      className="rounded-md"
      style={{ background: 'var(--surface-1)', border: '1px solid var(--divider-strong)' }}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="flex w-full items-center justify-between px-3 py-2 text-[13px] font-medium"
        style={{ color: 'var(--content-default)' }}
      >
        <span>택배사 코드 참조표{couriers.length > 0 ? ` (${couriers.length})` : ''}</span>
        <motion.span animate={{ rotate: open ? 180 : 0 }} transition={{ duration: 0.2 }} style={{ display: 'inline-flex' }}>
          <ChevronDown size={14} />
        </motion.span>
      </button>

      <AnimatePresence initial={false}>
        {open ? (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2, ease: [0.16, 1, 0.3, 1] }}
            style={{ overflow: 'hidden' }}
          >
            <div className="px-3 pb-3">
              {query.isPending ? (
                <p className="text-[12px]" style={{ color: 'var(--content-muted)' }}>
                  불러오는 중…
                </p>
              ) : query.isError ? (
                <p className="text-[12px]" style={{ color: 'var(--signal-danger)' }}>
                  택배사 코드를 불러오지 못했습니다.
                </p>
              ) : couriers.length === 0 ? (
                <p className="text-[12px]" style={{ color: 'var(--content-muted)' }}>
                  등록된 택배사가 없습니다.
                </p>
              ) : (
                <div className="grid grid-cols-2 gap-x-6 gap-y-1 sm:grid-cols-3 lg:grid-cols-4">
                  {couriers.map((c) => (
                    <div key={c.courierCode} className="flex items-baseline gap-2 text-[12px]">
                      <span
                        className="font-mono font-semibold"
                        style={{ color: 'var(--content-strong)' }}
                      >
                        {c.courierCode}
                      </span>
                      <span style={{ color: 'var(--content-muted)' }}>{c.nameKo}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </motion.div>
        ) : null}
      </AnimatePresence>
    </div>
  );
};
